// extracted by mini-css-extract-plugin
export default {"about__section":"about_about__section__xgVfv","about__section__title":"about_about__section__title__Si0wU"};